export enum FortuneReportEventName {
  FORTUNE_REPORT_PAGE_LANDING = "fortune_report_page_landing",
  FORTUNE_REPORT_DETAILS_INITIATED = "fortune_report_details_initiated",
  FORTUNE_REPORT_DETAILS_COMPLETED = "fortune_report_details_completed",
}

export interface FortuneReportEventPayloadMap {
  [FortuneReportEventName.FORTUNE_REPORT_PAGE_LANDING]: {
    bucket: string;
    abTestType: string;
    abTestCounter: number;
  };
  [FortuneReportEventName.FORTUNE_REPORT_DETAILS_COMPLETED]: {
    dateOfBirth: Date;
    timeOfBirth: Date;
    placeOfBirth: string;
  };
}
